import {Authorization} from "@app/core/shared/domain/authorization";

/**
 * Represents the credentials used for user authentication.
 * This class encapsulates a user's email and password,
 * which can be used to generate a Basic Authorization header.
 */
export class Credentials implements Authorization {
    email: string
    password: string

    constructor(email: string, password: string) {
        this.email = email;
        this.password = password;
    }

    /**
     * Produces the value for an HTTP Basic Authorization header.
     * @returns A string suitable for use as a Basic Authentication header.
     */
    getBasicAuthorization(): string {
        return 'Basic '+ btoa(this.email + ':' + this.password);

    }

}
